import * as PusherPushNotifications from "@pusher/push-notifications-web";

export default {

    client: new PusherPushNotifications.Client({
        instanceId: process.env.MIX_PUSHER_BEAMS_INSTANCE_ID,
    }),

    registerBrowser(userId) {

        const beamsTokenProvider = new PusherPushNotifications.TokenProvider({
            url: '/browser-notifiations/authenticate',
        });

        this.client
            .start()
            .then(() => this.client.setUserId(userId, beamsTokenProvider))
            .then(() => console.info("Successfully registered Browser notifications"))
            .catch(console.error);
    },

    unregisterBrowserWhenUserIsDifferent(currentUserId) {
        this.client
            .getUserId()
            .then(userId => {
                if (userId !== currentUserId) return this.client.stop();
            })
            .catch(console.error);
    }
}
